/**
 * LoginStrategy.js
 *
 * Copyright (c) apploft. GmbH
 */
export const LoginStrategy = Object.freeze({
  OIDC: Symbol('OpenID Connect'),
  CREDENTIALS: Symbol('Login with username and password'),
});
